import * as React from 'react'
import { Box, Icon, Grid } from '@design/pt-ui'

import Header from './Header'
import Formatsets from './Formatsets'
import DI from '../../app/di'

import Breadcrumb, { BreadcrumbItem } from '../../components/Breadcrumb'
import Loader from '../../components/Loader'

import { Type as ProjectViewState } from '../../model/project/state'
import { Descriptive } from '../../interfaces/base'
import { Project, ProjectId } from '../../interfaces/entities/project'
import { Creative, CreativeAction } from '../../interfaces/entities/creative'
import { Formatset, FormatsetId } from '../../interfaces/entities/formatset'
import { User } from '../../interfaces/entities/user'
import ProjectActionButton from '../../components/ProjectActionButton'
import { translateWithUserLocale } from '../../utils/i18n'
import { Platform } from '../../interfaces/entities/platform'

interface IProjectViewLayoutProps extends ProjectViewState {
  user: User
  clickOnProjectAction: (action: Descriptive, project: Project) => void
  doCreativeAction: (creative: Creative, action: CreativeAction) => void
  onProjectSave: (project: Project, meta: { created: boolean }) => any
  setProjectComment: (projectId: ProjectId, comment: string) => any
  addedFormatsets: (formatsets: Formatset[]) => any
  onRemoveFormatSet: (formatsetId: FormatsetId) => any
  getProject: (id: ProjectId) => void
  platforms: Platform[]
}

function ProjectView(props: IProjectViewLayoutProps) {
  const onBreadcrumbClick = (url: string) => {
    const history = DI.get('history')
    history.push(url)
  }

  const { project, loading } = props

  return project === null ? (
    <Loader
      variant="overlay"
      message={translateWithUserLocale('loaders.loading_project')}
    />
  ) : (
    <div>
      {loading ? (
        <Loader
          variant="overlay"
          message={translateWithUserLocale('loaders.loading_project')}
        />
      ) : null}
      <Box sx={{ marginBottom: 1 }}>
        <Breadcrumb separatorText={<Icon>chevron_right</Icon>}>
          <BreadcrumbItem
            sx={{ pl: 0 }}
            label={translateWithUserLocale('projects_overview')}
            href="/projects"
            onClick={onBreadcrumbClick}
          />
          <BreadcrumbItem label={project.name} active={true} labelLength={32} />
        </Breadcrumb>
      </Box>
      <Grid
        container={true}
        spacing={2}
        alignContent="center"
        alignItems="center">
        <Grid
          size={{
            md: 12,
          }}>
          <Box component="h1" sx={{ marginTop: 1, marginBottom: 0.5 }}>
            {project.name}
          </Box>
        </Grid>
        <Grid
          size={{
            md: 12,
          }}>
          <Header
            project={project}
            creativeStates={project.creativeStates}
            user={props.user}
            clickOnProjectAction={props.clickOnProjectAction}
            onProjectSave={props.onProjectSave}
            setProjectComment={props.setProjectComment}
            getProject={props.getProject}
          />
        </Grid>
        <Grid
          size={{
            sm: 12,
            md: 12,
          }}>
          <Formatsets
            project={project}
            user={props.user}
            doCreativeAction={props.doCreativeAction}
            onAddFormatsets={props.addedFormatsets}
            onRemoveFormatSet={props.onRemoveFormatSet}
            getProject={props.getProject}
            platforms={props.platforms}
          />
        </Grid>
        {props.project ? (
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-end',
              paddingLeft: '12px',
              paddingRight: '12px',
            }}>
            <ProjectActionButton
              project={props.project}
              user={props.user}
              clickOnProjectAction={props.clickOnProjectAction}
              getProject={props.getProject}
            />
          </Box>
        ) : null}
      </Grid>
    </div>
  )
}

export default ProjectView
